export const navigation = [
    {
      id: "1",
      title: "Home",
      url: "/",
    },
    {
      id: "2",
      title: "Shop",
      url: "/shop",
    },
    {
      id: "3",
      title: "Contact",
      url: "/contact",
    },
    {
      id: "4",
      title: "Cart",
      url: "/cart",
      onlyMobile: true,
    },
  ];

  export const topbarLinks = [
    {
      route: "/order/customer_details",
      label: "Customer details",
    },
    {
      route: "/order/delivery_details",
      label: "Delivery address",
    },
    {
      route: "/order/confirm_details",
      label: "Confirmation",
    },
  ];